import ReactHtmlParser from 'react-html-parser';
import viLang from './lang/vi.json';
import enLang from './lang/en.json';


export default class Language {
  constructor() {
  	this.loadJSON = this.loadJSON.bind(this);
  	this.setLang = this.setLang.bind(this);
  	this.getLang = this.getLang.bind(this);
  	this.g = this.g.bind(this);
    this.ghtml = this.ghtml.bind(this);
  }


  setLang(lang){
  	if (typeof window !== 'undefined') {
    	localStorage.setItem('hl', lang);
	}
  	
  }
  getLang(){
  	if (typeof window !== 'undefined') {
  		return localStorage.getItem('hl')||"vi"
  	}else{
  		return null;
  	}
  }

  

  g(key, fallback = ""){
  	var crL = this.getLang() == "en"?enLang:viLang
  	
  	if(!key){
  		return fallback
  	}
  
  	var arrkey = key.split(".");
  	let result = crL;
  	for (const item of arrkey) {
  		if (result && typeof result === 'object' && item in result) {
  			result = result[item];
  		} else {
  			return fallback;
  		}
  	}
  	return result ?? fallback
  }
  ghtml(key){
    return ReactHtmlParser(this.g(key, ""))
  }


  async loadJSON(){
  	let currentLang = localStorage.getItem('myValueInLocalStorage')
  	console.log(currentLang)
  }

}